module Meevo.Plugins.Client {

    export class RecentClientsService {

        private mostRecentClient: any = null;
        private _clientEmail: string;

        constructor(private $q: ng.IQService, private $rootScope: ng.IRootScopeService) {

        }

        public addToHistory(client: any, broadcast: boolean = true) {
            this.mostRecentClient = client;
            if (broadcast) {
                this.$rootScope.$broadcast(Meevo.Components.Common.Messages.CLIENT_SELECTED, client);
            }
        }

        set clientEmail(email: string) {
            this._clientEmail = email;
        }

        get clientEmail(): string {
            return this._clientEmail;
        }

        static factory(): Function {
            let svc = ($q: ng.IQService, $rootScope: ng.IRootScopeService) => {
                return new RecentClientsService($q, $rootScope);
            }

            svc.$inject = ['meevo.AppSettings', '$q', '$state', '$rootScope', 'meevo.components.common.SecurityService'];
            return svc;
        }
    }

    angular.module("meevo")
        .factory("meevo.plugins.client.RecentClientsService", RecentClientsService.factory());
}
